import createStellarIdenticon from 'stellar-identicon-js';

document.addEventListener("DOMContentLoaded", function (event) {
  let formConfirm = $('.confirm-whitelist')
  if (formConfirm.length > 0) {
    var checkAll = document.getElementById('checkall')
    checkAll.addEventListener('change', function () {
      if (checkAll.checked) {
        document.querySelectorAll('input[type="checkbox"]').forEach(e => e.checked = true)
      } else {
        document.querySelectorAll('input[type="checkbox"]').forEach(e => e.checked = false)
      }
    })

    formConfirm.find('input[type=radio]').each(function () {
      var input = $(this);
      if (formConfirm.find(`input[type=radio][name="${input.attr('name')}"]`).length == 1) {
        input.attr('type', 'checkbox')
      }
    })

    formConfirm.find('input[type=radio]').on('mouseup', function () {
      var me = this, checked = me.checked;
      setTimeout(function () {
        if (checked) me.checked = false
      }, 10)
    })
  }
})

document.addEventListener("DOMContentLoaded", function (event) {
  $('.identicon').each(function () {
    let $e = $(this),
      hash = $e.data('identicon'),
      text = $e.text();
    const canvas = createStellarIdenticon(hash);
    const renderedIcon = canvas.toDataURL()
    $e.html(`<img src="${renderedIcon}" width="12" height="12"> ${text}`)
  })
})
